module.exports = __webpack_public_path__ + "img/hyper-v.b1a7f7f5.png";